import type { JSX } from 'react';
import type { BariPreMdoReportData } from '@common/validation/customControls/bariPre/bariPreMdoReport/v1/bariPreMdoReportSchemaV1';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { mdoReportAdviceWithColor } from '@common/customControls/bariatrics';
import { BariPreNotIncludedAlert } from '@frontend/components/pages/episodeCategory/customControls/bariPre/BariPreNotIncludedAlert';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { addInclusieInZorgpadComponent } from '../../../bariatrics/readFormComponents';

export function BariPreMdoReportRead(): JSX.Element {
    const { processActivity, readSections } = useProcessActivityReadContext<BariPreMdoReportData>();

    return (
        <>
            <ReadForm components={getComponents()} />
            <BariPreNotIncludedAlert
                advice={processActivity.customControlData.inclusie_in_zorgpad}
                processActivityStatus={processActivity.status}
            />
        </>
    );

    function getComponents(): ComponentsMap {
        const map: ComponentsMap = new Map();
        addInclusieInZorgpadComponent<BariPreMdoReportData>(readSections, mdoReportAdviceWithColor, map);

        return map;
    }
}
